export var AnchorEnd;
(function (AnchorEnd) {
    AnchorEnd[AnchorEnd["target"] = 0] = "target";
    AnchorEnd[AnchorEnd["source"] = 1] = "source";
    AnchorEnd[AnchorEnd["both"] = 2] = "both";
})(AnchorEnd || (AnchorEnd = {}));
export var NodeShape;
(function (NodeShape) {
    NodeShape[NodeShape["circle"] = 0] = "circle";
    NodeShape[NodeShape["rect"] = 1] = "rect";
})(NodeShape || (NodeShape = {}));
export var ModelKind;
(function (ModelKind) {
    ModelKind["graph"] = "graph";
    ModelKind["node"] = "node";
    ModelKind["edge"] = "edge";
})(ModelKind || (ModelKind = {}));
export const isGraph = (element) => element && element.getKind() === ModelKind.graph;
export const isNode = (element) => element && element.getKind() === ModelKind.node;
export const isEdge = (element) => element && element.getKind() === ModelKind.edge;
export const ADD_CHILD_EVENT = 'element-add-child';
export const ELEMENT_VISIBILITY_CHANGE_EVENT = 'element-visibility-change';
export const REMOVE_CHILD_EVENT = 'element-remove-child';
export const NODE_COLLAPSE_CHANGE_EVENT = 'node-collapse-change';
export const NODE_POSITIONED_EVENT = 'node-positioned';
export const GRAPH_LAYOUT_END_EVENT = 'graph-layout-end';
export const GRAPH_POSITION_CHANGE_EVENT = 'graph-position-change';
//# sourceMappingURL=types.js.map